
import { defineComponent } from 'vue';
import CustomDialog from '~/components/Dialogs/CustomDialog.vue';
import CustomButton from '~/components/Buttons/CustomButton.vue';

export default defineComponent({
  name: 'LoanDetailsProductInfoDialog',

  components: { CustomDialog, CustomButton },

  props: {
    title: { type: String, default: '' },
    productInfo: { type: String, default: '' },
    width: { type: String, default: '21.5rem' },
  }
});
